import React, { useState, useCallback } from 'react';

import { OAuthButton } from './OAuthButton';
import { AppleIcon, ChevronDownIcon, GitHubIcon, GoogleIcon, MicrosoftIcon } from './OAuthIcons';

type Provider = 'google' | 'apple' | 'microsoft' | 'github';

interface OAuthSectionProps {
  onGoogleClick: () => void;
  onAppleClick: () => void;
  onMicrosoftClick: () => void;
  onGitHubClick: () => void;
  isLoading?: boolean;
}

const useProviderLoading = (props: OAuthSectionProps) => {
  const [loadingProvider, setLoadingProvider] = useState<Provider | null>(null);

  const handleClick = useCallback((provider: Provider) => {
    setLoadingProvider(provider);
    const handlers: Record<Provider, () => void> = {
      google: props.onGoogleClick, apple: props.onAppleClick, microsoft: props.onMicrosoftClick,
      github: props.onGitHubClick,
    };

    handlers[provider]();
  }, [props.onGoogleClick, props.onAppleClick, props.onMicrosoftClick, props.onGitHubClick]);

  const isAnyLoading = props.isLoading || loadingProvider !== null;

  return { loadingProvider, isAnyLoading, handleClick };
};

export const OAuthSection: React.FC<OAuthSectionProps> = (props) => {
  const { loadingProvider, isAnyLoading, handleClick } = useProviderLoading(props);
  const [showMore, setShowMore] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="oauth-section">
        <OAuthButton icon={<GoogleIcon />} label="Continue with Google" onClick={() => handleClick('google')} isLoading={loadingProvider === 'google'} disabled={isAnyLoading} />
        <OAuthButton icon={<AppleIcon />} label="Continue with Apple" onClick={() => handleClick('apple')} isLoading={loadingProvider === 'apple'} disabled={isAnyLoading} />
        <OAuthButton icon={<MicrosoftIcon />} label="Continue with Microsoft" onClick={() => handleClick('microsoft')} isLoading={loadingProvider === 'microsoft'} disabled={isAnyLoading} />

        <div className={`oauth-more-options ${showMore ? 'expanded' : ''}`}>
          <OAuthButton icon={<GitHubIcon />} label="Continue with GitHub" onClick={() => handleClick('github')} isLoading={loadingProvider === 'github'} disabled={isAnyLoading} />
        </div>
      </div>
      <span
        className="oauth-toggle-btn"
        style={{ alignSelf: 'center' }}
        onClick={() => setShowMore(!showMore)}
      >
        <ChevronDownIcon className={`oauth-toggle-icon ${showMore ? 'rotated' : ''}`} />
      </span>
    </div>
  );
};
